import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../../modules/jobFunctions/jobVendorActions'
import { constants as revisionConstants } from '../../modules/revisionActions'
import { constants as purchaseOrderActionsConstants } from '../../modules/jobFunctions/purchaseOrderActions'
import * as api from '../../api/job/vendors'

function* jobVendorsRefresh(action) {
  try {
    const payload = yield call(api.getJobVendors, action.jobId)
    yield put({ type: constants.JOB_VENDORS_REFRESH.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_VENDORS_REFRESH.FAILED,
      message: e.message || e
    })
  }
}

function* watchJobVendors() {
  yield takeLatest(constants.JOB_VENDORS_REFRESH.ACTION, jobVendorsRefresh)
}

function* getAllVendors(action) {
  try {
    const payload = yield call(api.getAllVendors)
    yield put({ type: constants.GET_ALL_VENDORS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_ALL_VENDORS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetAllVendors() {
  yield takeLatest(constants.GET_ALL_VENDORS.ACTION, getAllVendors)
}

function* sagaAddJobVendor(action) {
  try {
    const payload = {
      job_id: action.jobId,
      vendor_id: action.vendorId
    }

    yield call(api.addJobVendor, payload)
    yield put({ type: constants.JOB_VENDOR_CREATE.SUCCESS, payload })
    yield call(jobVendorsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_VENDOR_CREATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchAddJobVendor() {
  yield takeLatest(constants.JOB_VENDOR_CREATE.ACTION, sagaAddJobVendor)
}

function* sagaUpdateJobVendor(action) {
  try {
    const payload = {
      job_id: action.jobId,
      vendor_id: action.vendorId
    }
    yield call(api.updateJobVendor, payload)
    yield put({ type: constants.JOB_VENDOR_UPDATE.SUCCESS, payload })
    yield call(jobVendorsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_VENDOR_UPDATE.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateJobVendor() {
  yield takeLatest(constants.JOB_VENDOR_UPDATE.ACTION, sagaUpdateJobVendor)
}

function* sagaDeleteJobVendor(action) {
  try {
    const payload = {
      jobId: action.jobId,
      organizationId: action.organizationId
    }
    yield call(api.deleteJobVendor, payload)
    yield put({ type: constants.JOB_VENDOR_DELETE.SUCCESS, payload })
    yield call(jobVendorsRefresh, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.JOB_VENDOR_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteJobVendor() {
  yield takeLatest(constants.JOB_VENDOR_DELETE.ACTION, sagaDeleteJobVendor)
}

function* sagaCreateVendorPurchaseOrder(action) {
  try {
    const payload = {
      job_id: action.jobId,
      vendor_id: action.vendorId,
      basic_info: action.basicInfoData,
      section_data: action.sectionData,
      section_items_data: action.itemsData,
      created_by_id: action.userId,
      updated_by_id: action.userId
    }
    yield call(api.createVendorPurchaseOrder, payload)
    yield put({ type: constants.CREATE_VENDOR_PURCHASE_ORDER.SUCCESS, payload })
    yield call(sagaGetVendorPurchaseOrder, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_VENDOR_PURCHASE_ORDER.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateVendorPurchaseOrder() {
  yield takeLatest(constants.CREATE_VENDOR_PURCHASE_ORDER.ACTION, sagaCreateVendorPurchaseOrder)
}

function* sagaUpdateVendorPurchaseOrder(action) {
  try {
    const payload = {
      job_id: action.jobId,
      purchase_order_id: action.purchaseOrderId,
      vendor_id: action.vendorId,
      basic_info: action.basicInfoData,
      section_data: action.sectionData,
      section_items_data: action.itemsData,
      grand_total: action.grandTotal,
      created_by_id: action.userId,
      updated_by_id: action.userId
    }

    yield call(api.updateVendorPurchaseOrder, payload)
    yield put({ type: constants.UPDATE_VENDOR_PURCHASE_ORDER.SUCCESS, payload })
    yield put({
      type: purchaseOrderActionsConstants.GET_PURCHASE_ORDER.ACTION,
      purchaseOrderId: action.purchaseOrderId
    })
    yield put({
      type: revisionConstants.GET_REVISIONS.ACTION,
      targetId: action.purchaseOrderId,
      table: 'purchase_order'
    })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_VENDOR_PURCHASE_ORDER.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateVendorPurchaseOrder() {
  yield takeLatest(constants.UPDATE_VENDOR_PURCHASE_ORDER.ACTION, sagaUpdateVendorPurchaseOrder)
}

function* sagaGetVendorPurchaseOrder(action) {
  try {
    const payload = yield call(api.getVendorPurchaseOrder, action.jobId)
    yield put({ type: constants.GET_VENDOR_PURCHASE_ORDER.SUCCESS, payload })
    action.next && action.next(null, payload)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_VENDOR_PURCHASE_ORDER.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetVendorPurchaseOrder() {
  yield takeLatest(constants.GET_VENDOR_PURCHASE_ORDER.ACTION, sagaGetVendorPurchaseOrder)
}

// ATTACHMENT SAGAS
function* uploadAttachments(action) {
  try {
    const payload = {
      formData: action.formData,
      jobId: action.jobId,
      organizationId: action.organizationId
    }

    yield call(api.uploadAttachments, payload)
    yield put({ type: constants.UPLOAD_JOB_VENDOR_ATTACHMENT.SUCCESS, payload })
    yield call(getAttachments, {
      jobId: action.jobId,
      organizationId: action.organizationId
    })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPLOAD_JOB_VENDOR_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchUploadAttachments() {
  yield takeLatest(constants.UPLOAD_JOB_VENDOR_ATTACHMENT.ACTION, uploadAttachments)
}

function* getAttachments(action) {
  try {
    const param = {
      jobId: action.jobId,
      organizationId: action.organizationId
    }
    const payload = yield call(api.getAttachments, param)
    yield put({ type: constants.GET_JOB_VENDOR_ATTACHMENTS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_JOB_VENDOR_ATTACHMENTS.FAILED,
      message: e.message || e
    })
  }
}

function* sagaQuickAddVendor(action) {
  try {
    const payload = {
      vendor_data: action.vendor,
      user_id: action.userId
    }
    yield call(api.quickAddVendor, payload)
    yield put({ type: constants.QUICK_ADD_VENDOR.SUCCESS, payload })
    yield call(getAllVendors)
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.QUICK_ADD_VENDOR.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetAttachments() {
  yield takeLatest(constants.GET_JOB_VENDOR_ATTACHMENTS.ACTION, getAttachments)
}

function* updateAttachmentDescription(action) {
  try {
    const payload = {
      attachmentId: action.attachmentId,
      created_by_id: action.userId,
      updated_by_id: action.userId,
      user_id: 1,
      description: action.description
    }
    yield call(api.updateAttachmentDescription, payload)
    yield put({ type: constants.UPDATE_JOB_VENDOR_ATTACHMENT_DESCRIPTION.SUCCESS, payload })
    yield call(getAttachments, { jobId: action.jobId, organizationId: action.organizationId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_JOB_VENDOR_ATTACHMENT_DESCRIPTION.FAILED,
      message: e.message || e
    })
  }
}

function* watchUpdateAttachmentDescription() {
  yield takeLatest(
    constants.UPDATE_JOB_VENDOR_ATTACHMENT_DESCRIPTION.ACTION,
    updateAttachmentDescription
  )
}

function* deleteAttachment(action) {
  try {
    const param = {
      attachmentId: action.attachmentId,
      jobId: action.jobId,
      organizationId: action.organizationId
    }

    yield call(api.deleteAttachment, param)
    yield put({ type: constants.DELETE_JOB_VENDOR_ATTACHMENT.SUCCESS, param })
    yield call(getAttachments, {
      jobId: action.jobId,
      organizationId: action.organizationId
    })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_JOB_VENDOR_ATTACHMENT.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteAttachments() {
  yield takeLatest(constants.DELETE_JOB_VENDOR_ATTACHMENT.ACTION, deleteAttachment)
}

function* watchQuickAddVendor() {
  yield takeLatest(constants.QUICK_ADD_VENDOR.ACTION, sagaQuickAddVendor)
}

function* sagaDeletePurchaseOrder(action) {
  try {
    const payload = {
      purchaseOrderId: action.purchaseOrderId
    }
    yield call(api.deletePurchaseOrder, payload)
    yield put({ type: constants.PURCHASE_ORDER_DELETE.SUCCESS, payload })
    yield call(sagaGetVendorPurchaseOrder, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.PURCHASE_ORDER_DELETE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeletePurchaseOrder() {
  yield takeLatest(constants.PURCHASE_ORDER_DELETE.ACTION, sagaDeletePurchaseOrder)
}

export function* rootSaga() {
  // add more sagas here
  yield all([
    fork(watchJobVendors),

    fork(watchAddJobVendor),
    fork(watchUpdateJobVendor),
    fork(watchDeleteJobVendor),

    fork(watchGetAllVendors),

    fork(watchCreateVendorPurchaseOrder),
    fork(watchUpdateVendorPurchaseOrder),
    fork(watchGetVendorPurchaseOrder),

    fork(watchUploadAttachments),
    fork(watchGetAttachments),
    fork(watchUpdateAttachmentDescription),
    fork(watchDeleteAttachments),

    fork(watchQuickAddVendor),

    fork(watchDeletePurchaseOrder)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/jobFunctions/jobVendorSaga.js